module.exports = __webpack_public_path__ + "img/comments.f6a6b614.svg";